import script from "./CompetitionCreateForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionCreateForm.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionCreateForm.vue?vue&type=style&index=0&id=143f9e4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-143f9e4f"]])

export default __exports__